import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { setCurrentNavigation } from "../../slices/navigationSlice";
import useMount from '../../hooks/useMount';
import BackButton from "../Commons/BackButton";
import useLog from '../../hooks/useLog';

import { getLabel } from "../../tools/Dictionary";
import { MdOutlineLocationOn, MdOutlineEmail, MdPhone } from "react-icons/md";

import "./Contact.css";

const ContactPage = (props) =>
{

  //Logs
  const { logPageView } = useLog();

  //Query
  let [searchParam] = useSearchParams();


  //Props
  const IsDesktop = props.IsDesktop;

  //Redux
  const Dispatch = useDispatch();



  useMount(() =>
  {
    let currentProduct = {
      _id: searchParam.get('product'),
      code: searchParam.get('productCode'),
    };

    logPageView("Contact", { productId: currentProduct?._id, productCode: currentProduct?.code });

    Dispatch(setCurrentNavigation("Contact"));
  }, []);

  return (
    <div className="page_body_cont">
      <BackButton
        Hide={IsDesktop}
      />
      <div className="page_title" style={{ marginBottom: "20px" }}>
        {getLabel("Contact", "Contact")}
      </div>
      

      <div className='contact_cont'>
        <div className='contact_row'>
          <div className='contact_icon'>
            <MdOutlineLocationOn />
          </div>
          <div className="contact_value">
            180 3e Avenue <br/>
            L'Islet QC  G0R 2C0 <br/>
            CANADA
          </div>
        </div>
        <div className='contact_row'>
          <div className='contact_icon'>
            <MdOutlineEmail />
          </div>
          <div className="contact_value">
            <a href="mailto:	info@innovairsolutions.com">
              info@innovairsolutions.com
            </a>
          </div>
        </div>
        <div className='contact_row'>
          <div className='contact_icon'>
            <MdPhone />
          </div>
          <div className="contact_value">
            <a href="tel:+18004637043">
              1 800-463-7043
            </a>
          </div>
        </div>
      </div>
    </div>
  )

   

};

export default ContactPage;